import { withTranslate } from "@pathwright/ui/src/components/"
import Button from "@pathwright/ui/src/components/button/Button"
import IconButton from "@pathwright/ui/src/components/button/IconButton"
import View from "@pathwright/ui/src/components/ui/View"
import { Text } from "lib/core/components/text"
import "./AboutAuthors.css"

const AboutAuthor = ({
  id,
  display_name,
  bio,
  image,
  slug,
  resources_count,
  canEdit,
  t
}) => (
  <div className="AboutAuthor">
    <img className="AboutAuthor__img" src={image} />
    <h4 className="AboutAuthor__name">{display_name}</h4>
    <Text className="AboutAuthor__bio" html={bio} />
    {/* NOTE: resources_count will not exist on the author due to this change: https://github.com/duointeractive/coursebook/commit/5f0cbd07b3eaf996884b3b7a34c5e1df0c39078b */}
    {resources_count > 1 ? (
      <Button styleType="text" to={`/library/by/author/${slug}/`}>
        {t("resource.about.view_more_by")} {display_name}
      </Button>
    ) : undefined}
  </div>
)

AboutAuthor.displayName = "AboutAuthor"

const AboutAuthors = ({ resource, authors, canEdit, t }) => (
  <View className="AboutAuthors" paddingTop>
    <h6>
      <span></span>
      {/* {t("resource.about.authors.heading", {
        author: t(
          `resource.about.authors.${pluralize("author", authors.length)}`
        )
      })} */}
      {canEdit && !resource.licensed_from_resource && (
        <IconButton
          styleType="secondary"
          icon="edit"
          to={`/manage/resource/${resource.id}/details/`}
        />
      )}
    </h6>
    {authors.map((author) => (
      <AboutAuthor
        {...Object.assign({ key: author.id, canEdit: canEdit, t }, author)}
      />
    ))}
  </View>
)

AboutAuthors.displayName = "AboutAuthors"

export default withTranslate(AboutAuthors)
